/**
 * NS Variant Cards - selection state fix.
 *
 * Bug: clicking a card did not visibly mark it as selected (checkmark,
 * thicker border, raised shadow) until the page was refreshed. CSS
 * `:checked` alone did not reliably repaint after Vetro's native
 * variant-picker section-replace cycle on every option change.
 *
 * Fix: listen for native `change` events on any .ns-vc__input inside a
 * .ns-vc component (event delegation, so this keeps working even after
 * Vetro replaces the surrounding section HTML) and explicitly toggle
 * `.is-selected` on the matching card. This does not interfere with
 * Vetro's own variant-picker logic in global.js - it only adds the
 * visual selected-state class, it never reads or writes price, cart, or
 * variant-id data itself.
 */
(function () {
  function markSelected(root) {
    if (!root) return;
    var inputs = root.querySelectorAll('.ns-vc__input');
    inputs.forEach(function (input) {
      var card = input.nextElementSibling;
      if (!card || !card.classList.contains('ns-vc__card')) return;
      card.classList.toggle('is-selected', input.checked);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('ns-vc__input')) return;
    var root = input.closest('.ns-vc');
    markSelected(root);
  });

  // Re-apply on initial load and whenever Vetro swaps in fresh section
  // HTML, since the freshly-fetched markup already has the correct
  // `checked` attribute server-side - this just keeps the visual class
  // in sync with it immediately rather than waiting on any other event.
  function markAll() {
    document.querySelectorAll('.ns-vc').forEach(markSelected);
  }
  document.addEventListener('DOMContentLoaded', markAll);
  document.addEventListener('product:updateNow', markAll);
  document.addEventListener('product:updateInfo', markAll);
  markAll();
})();
